import { render, staticRenderFns } from "./dialog-deletepassword.vue?vue&type=template&id=d4e4a632&"
import script from "./dialog-deletepassword.vue?vue&type=script&lang=js&"
export * from "./dialog-deletepassword.vue?vue&type=script&lang=js&"
import style0 from "./dialog-deletepassword.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports